import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { AddUntersuchungsmaterialDialogComponent } from './add-untersuchungsmaterial-dialog/add-untersuchungsmaterial-dialog.component';
import { Untersuchungsmaterial } from './untersuchungsmaterial';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-untersuchungsmaterialien',
    templateUrl: './untersuchungsmaterialien.component.html',
    styleUrls: ['./untersuchungsmaterialien.component.scss'],
})
export class UntersuchungsmaterialienComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly api: KieneTableService,
        private readonly notification: MessageService,
        private readonly router: Router,
    ) {}

    ngOnInit() {
        this.tableDescriptor.headline = 'Untersuchungsmaterialien';
        this.tableDescriptor.uniqueIdentifier = 'Untersuchungsmaterialien';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'untersuchungsmaterial/';
        this.tableDescriptor.route = '/labor/unteruchungsmaterialien/';
        this.tableDescriptor.nameOfIdField = 'untersuchungsmaterial_id';
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetails = false;

        this.tableDescriptor.columns.push(new TableColumn('bezeichnung', 'Untersuchungsmaterial'));
        this.tableDescriptor.columns.push(new TableColumn('tierart', 'Tierart'));

        this.tableDescriptor.options.push(new TableOption(this.edit.bind(this), 'Bearbeiten', 'edit', 1422));
        this.tableDescriptor.options.push(
            new TableOption(
                this.navigateToUntersuchungsmaterialKonfigurator.bind(this),
                'Konfigurieren',
                'settings',
                1422,
            ),
        );

        this.tableDescriptor.permissionCreate = 1422;
        this.tableDescriptor.permissionView = 1421;

        this.tableDescriptor.initialSortColumn = 'bezeichnung';
        this.tableDescriptor.initialSortDirection = 'asc';
        this.tableDescriptor.addVoid = this.openAddDialog.bind(this);
    }

    private navigateToUntersuchungsmaterialKonfigurator(untersuchungsmaterial: Untersuchungsmaterial) {
        this.router
            .navigate(['labor', 'untersuchungsmaterialkonfigurator', untersuchungsmaterial.untersuchungsmaterial_id])
            .then();
    }

    edit(untersuchungsmaterial: Untersuchungsmaterial) {
        // Material nachladen, damit die Artikelstruktur enthalten ist
        this.api
            .getOne(
                this.apiBaseUrl + 'untersuchungsmaterial/read_one.php',
                'untersuchungsmaterial_id',
                untersuchungsmaterial.untersuchungsmaterial_id?.toString(),
            )
            .subscribe({
                next: (material: Untersuchungsmaterial) => {
                    this.openAddDialog(material);
                },
                error: err => {
                    this.notification.errorMessage('Fehler beim Nachladen!', err);
                },
            });
    }

    openAddDialog(untersuchungsmaterial?: Untersuchungsmaterial) {
        const dialogRef = this.dialog.open(AddUntersuchungsmaterialDialogComponent, {
            width: '50%',
            minWidth: '300px',
            data: { untersuchungsmaterial: untersuchungsmaterial },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.api.updateEntity(this.apiBaseUrl + 'untersuchungsmaterial/update.php', result).subscribe(
                    () => {
                        this.notification.infoMessage('Untersuchungsmaterial erfolgreich gespeichert!');
                        this.api.reload();
                    },
                    error => {
                        this.notification.errorMessage('Untersuchungsmaterial konnte nicht gespeichert werden!', error);
                    },
                );
            }
        });
    }
}
